import {first} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {Component} from '@angular/core';
import {CacheService} from '../../cache/cache.service';
import {LanguageService} from '../../language/language.service';

@Component({
  selector: 'confirm-dialog',
  template: `
    <app-dialog>
      <app-dialog-title>{{ title }}</app-dialog-title>
      <p mat-dialog-content [innerHtml]="message"></p>
      <app-dialog-action-button (click)="dialogRef.close(false)">
        {{ falseLabelDisplay }}
      </app-dialog-action-button>
      <app-dialog-action-button [primary]="true" (click)="dialogRef.close(true)">
        {{ trueLabelDisplay }}
      </app-dialog-action-button>
    </app-dialog>
  `,
  standalone: false,
})
export class ConfirmDialog {
  public title: string;
  public message: string;
  public trueLabel: string = null;
  public falseLabel: string = null;

  get trueLabelDisplay(): string {
    return this.trueLabel ? this.trueLabel : 'OK';
  }

  get falseLabelDisplay(): string {
    return this.falseLabel ? this.falseLabel : 'Cancel';
  }

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    cacheService: CacheService,
  ) {
    cacheService
      .getLanguageResource()
      .pipe(first())
      .subscribe(lr => {
        if (this.trueLabel == null) {
          this.trueLabel = LanguageService.translate('OK', 'OK', lr);
        }
        if (this.falseLabel == null) {
          this.falseLabel = LanguageService.translate('Cancel', 'Cancel', lr);
        }
      });
  }
}
